import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ChannelNames } from '../schema/constants/visual-constants';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const getChannelHelpText = channelName => {
  switch (channelName) {
    case ChannelNames.DETAIL:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-snowflake.channels-help-text.detail-channel_jsx",
        elements: {
          UILink: Link
        },
        options: {
          external: true,
          href: 'https://knowledge.hubspot.com/reports/create-reports-with-the-custom-report-builder#scatter-channels',
          target: 'blank'
        }
      });
    case ChannelNames.SIZING:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-snowflake.channels-help-text.sizing-channel_jsx",
        elements: {
          UILink: Link
        },
        options: {
          external: true,
          href: 'https://knowledge.hubspot.com/reports/create-reports-with-the-custom-report-builder#scatter-channels',
          target: 'blank'
        }
      });
    default:
      return null;
  }
};